import {Popover, PopoverProps} from '@mui/material';
import {useDebounceEffect} from 'hooks';
import React, {useState} from 'react';

export interface AppPopoverProps extends Omit<PopoverProps, 'open' | 'children'> {
    renderElement: (handleOpen: (event: any) => void, open: boolean) => React.ReactNode;
    renderChildren: (handleOpen: (event: any) => void, open: boolean) => React.ReactNode;
}
export const AppPopover: React.FC<AppPopoverProps> = ({renderChildren, renderElement, ...props}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [dummmyEvent, setDummyEvent] = useState<any>(null);
    const open = React.useMemo(() => Boolean(anchorEl), [anchorEl]);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setDummyEvent(event.currentTarget);
    };
    useDebounceEffect(
        () => {
            setAnchorEl(anchorEl ? null : dummmyEvent);
        },
        [dummmyEvent],
        100,
    );

    return (
        <>
            {renderElement(handleClick, open)}
            <Popover
                anchorEl={anchorEl}
                open={!!anchorEl}
                BackdropProps={{
                    style: {
                        backgroundColor: 'transparent',
                    },
                }}
                elevation={4}
                onClose={handleClick}
                {...props}
            >
                {renderChildren(handleClick, open)}
            </Popover>
        </>
    );
};

export default AppPopover;
